module.exports = __webpack_public_path__ + "static/media/aboutSection1.664a685c.png";